/// REDUX ///
import { useAppDispatch } from "api/hooks/apiHook";
import { useAppSelector } from "api/hooks/apiHook";
/// REACT ///
import { Fragment } from "react";
import { useEffect } from "react";
import { useState } from "react";
/// TYPES ///
import { IShopColor } from "api/types/shop_material";
import { IShopColorOption } from "api/types/shop_quote/color_option";
import { IShopMaterial } from "api/types/shop_material";
/// ACTIONS ///
import { deleteShopColorOption } from "api/actions/shop_quote";
import { updateShopColorOption } from "api/actions/shop_quote";
import { updateLocalShopColorOption } from "api/actions/shop_quote";
import { markShopQuoteChanged } from "api/actions/shop_quote";
/// COMPONENTS ///
import MainColor from "components/quote/color_options/area/row/color";
import ShopCreateMaterial from "../../dialog/material/create";
import ShopCreateColor from "../../dialog/color/create";
import ShopUpdateMaterial from "../../dialog/material/update";
import ShopUpdateColor from "../../dialog/color/update";
/// LODASH ///
import { filter } from "lodash";
/// VALUES ///
import { QUARTZ } from "values/material";

interface Props {
  color_option: IShopColorOption,
  description: string,
}

export default function ShopColorOptionItem({ color_option, description }: Props) {
  const dispatch = useAppDispatch();
  const { colors } = useAppSelector((state) => state.shop_material);
  const { materials } = useAppSelector((state) => state.shop_material);
  const [filt_mats, setFiltMats] = useState<IShopMaterial[]>([]);
  const [filt_colors, setFiltColors] = useState<IShopColor[]>([]);
  const [current_color, setCurrentColor] = useState<IShopColor>({});
  const [current_material, setCurrentMaterial] = useState<IShopMaterial>({});
  const [selected_type, setSelectedType] = useState<string>(color_option?.material_type ?? QUARTZ);
  const [selected_material, setSelectedMaterial] = useState<number>(0);
  const [selected_color, setSelectedColor] = useState<number>(0);
  const [create_material_open, setCreateMaterialOpen] = useState<boolean>(false);
  const [update_material_open, setUpdateMaterialOpen] = useState<boolean>(false);
  const [create_color_open, setCreateColorOpen] = useState<boolean>(false);
  const [edit_color_open, setEditColorOpen] = useState<boolean>(false);

  useEffect(() => {
    setSelectedType(color_option?.material_type);
  }, [color_option?.material_type]);

  useEffect(() => {
    for (let i = 0; i < filt_mats.length; i++) {
      if (filt_mats[i].id === color_option?.material) {
        setSelectedMaterial(filt_mats[i].id);
        setCurrentMaterial(filt_mats[i]);
      }
    }
  }, [filt_mats, color_option?.material]);

  useEffect(() => {
    for (let i = 0; i < filt_colors.length; i++) {
      if (filt_colors[i].id === color_option?.color) {
        setSelectedColor(filt_colors[i].id);
      }
    }
  }, [filt_colors, color_option?.color]);

  useEffect(() => {
    setFiltMats(filter(materials, { "material_type": selected_type }));
  }, [setFiltMats, materials, selected_type]);

  useEffect(() => {
    setFiltColors(filter(colors, { "material": selected_material }));
  }, [colors, selected_material, setFiltColors]);

  const handleCurrentMaterial = (material: IShopMaterial) => {
    dispatch(updateLocalShopColorOption({ ...color_option, material: material.id }));
    setSelectedType(material.material_type);
    setSelectedMaterial(material.id);
    setCurrentMaterial(material);
  }

  const handleCurrentColor = (color: IShopColor) => {
    dispatch(updateLocalShopColorOption({ ...color_option, color: color.id }));
    setSelectedColor(color.id);
    setCurrentColor(color);
    saveColor(
      color.id,
      color.material,
      current_material.material_type,
      current_material.name,
      color.name,
      color.length,
      color.width
    );
  }

  const selectMaterial = (material: IShopMaterial) => {
    setSelectedMaterial(material.id);
    setCurrentMaterial(material);
  }

  const selectColor = (color: IShopColor) => {
    setSelectedColor(color.id);
    setCurrentColor(color);
  }

  const saveColor = (
    color_id: number,
    material_id: number,
    material_type: string,
    material_name: string,
    color_name: string,
    color_length: number,
    color_width: number
  ) => {
    dispatch(updateShopColorOption({
      ...color_option,
      color: color_id,
      material: material_id,
      material_type: material_type,
      material_name: `${material_name} ${color_name}`,
      material_length: color_length,
      material_width: color_width
    }));
    dispatch(markShopQuoteChanged());
  }

  return (
    <Fragment>
      <MainColor
        description={description}
        colors={filt_colors}
        materials={filt_mats}
        saveColor={saveColor}
        selected_type={selected_type}
        setSelectedType={setSelectedType}
        selected_material={selected_material}
        setSelectedMaterial={selectMaterial}
        selected_color={selected_color}
        setSelectedColor={selectColor}
        setCreateColorOpen={setCreateColorOpen}
        setEditColorOpen={setEditColorOpen}
        setCreateMaterialOpen={setCreateMaterialOpen}
        setEditMaterialOpen={setUpdateMaterialOpen}
        deleteColorOption={() => dispatch(deleteShopColorOption(color_option))}
        showNaturalStone />
      <ShopCreateMaterial
        open={create_material_open}
        setOpen={setCreateMaterialOpen}
        setCurrent={handleCurrentMaterial}
        current_type={selected_type} />
      <ShopUpdateMaterial
        open={update_material_open}
        setOpen={setUpdateMaterialOpen}
        current_material={current_material} />
      <ShopCreateColor
        open={create_color_open}
        setOpen={setCreateColorOpen}
        setCurrent={handleCurrentColor}
        current_material={current_material}
        area={null} />
      <ShopUpdateColor
        open={edit_color_open}
        setOpen={setEditColorOpen}
        current_color={current_color}
        current_material={current_material}
        area={null} />
    </Fragment>
  );
}
